import React, { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
// routes
// theme
import { styled } from '@mui/material'
// components
import ScrollToTop from './components/scroll-to-top'
import { routes } from './routes/index.routes'
import LoginPage from './pages/LoginPage'
// import DashboardAppPage from './pages/DashboardAppPage'
import UserPage from './pages/UserPage'
import Nav from './layouts/dashboard/nav'
import Header from './layouts/dashboard/header'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { ProtectedRoute } from './routes/ProtectedRoute'
import ClientCompaniesPage from './pages/ClientCompaniesPage'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { accountMatchesRealm } from './config/msalConfig'

// ----------------------------------------------------------------------

export default function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const { accounts, inProgress } = useMsal()
  // Authenticated only for the CURRENT environment's tenant (the MSAL cache is
  // shared across environments, so a leftover account from another env must not
  // count as signed in here).
  const isAuthenticated = accounts.some(accountMatchesRealm)

  const StyledRootDashboard = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
  })

  const StyledRootLogin = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  }))

  const Container =
    location.pathname !== routes.login || location.pathname !== '/' ? StyledRootDashboard : StyledRootLogin

  useEffect(() => {
    // Only redirect once MSAL has finished initializing to avoid race conditions
    if (inProgress !== InteractionStatus.None) return

    if (isAuthenticated && (location.pathname === routes.login || location.pathname === routes.index)) {
      navigate(routes.users, { replace: true })
    }
  }, [isAuthenticated, inProgress, location.pathname, navigate])

  return (
    <>
      <ScrollToTop />
      <Container>
        {isAuthenticated && location.pathname !== routes.login && location.pathname !== routes.index && (
          <>
            <Nav openNav={open} onCloseNav={() => setOpen(false)} />
            <Header onOpenNav={() => setOpen(true)} />
          </>
        )}
        <Routes>
          <Route
            index
            element={isAuthenticated ? <Navigate to={routes.users} replace /> : <LoginPage />}
          />
          <Route
            path={routes.login}
            element={isAuthenticated ? <Navigate to={routes.users} replace /> : <LoginPage />}
          />
          <Route
            path={routes.users}
            element={
              <ProtectedRoute>
                <UserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.clientCompanies}
            element={
              <ProtectedRoute>
                <ClientCompaniesPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Container>
      <ToastContainer position="top-right" />
    </>
  )
}
